import React, { useEffect, useState } from 'react';
const INITIAL_SECONDS = 29 * 60 + 52; // 29:52
let globalTimeLeft = INITIAL_SECONDS;
let listeners: Array<(t: number) => void> = [];
let intervalId: ReturnType<typeof setInterval> | null = null;
function startGlobalTimer() {
  if (intervalId !== null) return;
  intervalId = setInterval(() => {
    if (globalTimeLeft > 0) {
      globalTimeLeft -= 1;
      listeners.forEach(fn => fn(globalTimeLeft));
    } else {
      if (intervalId !== null) clearInterval(intervalId);
    }
  }, 1000);
}
export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(globalTimeLeft);
  useEffect(() => {
    listeners.push(setTimeLeft);
    startGlobalTimer();
    return () => {
      listeners = listeners.filter(fn => fn !== setTimeLeft);
    };
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return {
    minutes,
    seconds,
    formattedTime: `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
    isExpired: timeLeft <= 0
  };
}